module.exports = __webpack_public_path__ + "static/media/5.cc0d4983.ogg";